import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IEmailSent } from '../../data/interfaces/email-sent.interface';
import { CommunicationService } from '../../data/services/view/communication.service';
import { EMAIL_STATUS_INFO } from '../../data/constants/communications.constants';
import { EmailStatusEnum } from '../../data/enum/email-status.enum';

@Component({
  selector: 'app-email-detail',
  templateUrl: './email-detail.component.html',
  styleUrls: ['./email-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailDetailComponent implements OnInit, OnDestroy {
  statusInfo = EMAIL_STATUS_INFO;

  constructor(public communicationService: CommunicationService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.email = null;
  }

  get email(): IEmailSent | null {
    return this.communicationService.selectedEmail;
  }

  set email(value: IEmailSent | null) {
    this.communicationService.selectedEmail = value;
  }

  get visible(): boolean {
    return this.communicationService.showDetail;
  }

  set visible(value: boolean) {
    this.communicationService.showDetail = value;
    if (!value) {
      this.communicationService.selectedEmail = null;
    }
  }

  getStatusInfo() {
    if (!this.email) {
      return this.statusInfo['PENDING'];
    }
    return this.statusInfo[this.email.status as keyof typeof EMAIL_STATUS_INFO] || this.statusInfo['PENDING'];
  }

  close() {
    this.visible = false;
  }

  openTracking() {
    if (!this.email) return;
    
    this.visible = false;
    this.communicationService.trackingEvents = 
      this.communicationService.buildTrackingTimeline(this.email);
    this.communicationService.showTracking = true;
  }

  openPreview() {
    if (!this.email) return;
    
    this.visible = false;
    this.communicationService.previewHtml = this.email.bodyHtml || '';
    this.communicationService.showPreview = true;
  }

  showEngagementMetrics(): boolean {
    if (!this.email) return false;
    return this.email.status !== EmailStatusEnum.FAILED && 
           this.email.status !== EmailStatusEnum.BOUNCED;
  }

  formatDate(date: Date | string | undefined): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('es-MX', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
